/**
 * Imports
 */
import { createReducer } from '@reduxjs/toolkit';

import { collapseSidebar, hideSidebar, openSidebar } from './actions';

/**
 * Types
 */
export interface SidebarState {
  visible: boolean;
  collapsed: boolean;
}

/**
 * Constants
 */
const INITIAL_STATE: SidebarState = {
  visible: true,
  collapsed: false,
};

/**
 * `sidebar` reducer
 */
const sidebarReducer = createReducer(INITIAL_STATE, {
  /**
   * COLLAPSE_SIDEBAR
   */
  [collapseSidebar.type]: (state) => {
    state.collapsed = true;
  },
  /**
   * HIDE_SIDEBAR
   */
  [hideSidebar.type]: (state) => {
    state.visible = false;
  },
  /**
   * OPEN_SIDEBAR
   */
  [openSidebar.type]: (state) => {
    state.collapsed = false;
    state.visible = true;
  },
});

/**
 * Exports
 */
export default sidebarReducer;
